import React from 'react';

const Construction = () => {
    return (
        <div className="industry-section">
            <div className="industry-content">
                <h2>Construction & Engineering</h2>
                <p>
                    Elevate your construction projects with our precision LiDAR solutions. From initial site surveys to progress monitoring and final as-built documentation, our technology provides accurate 3D models that streamline workflows, reduce costs, and minimize errors.
                </p>
                <p>
                    Our detailed measurements enable precise earth volume calculations, cut-and-fill analysis, and watershed modeling to optimize site preparation and prevent erosion issues. During construction, regular scans allow for quality control and deviation analysis against design models.
                </p>
                <div className="industry-features">
                    <span className="feature-item">Earth Volume Computation</span>
                    <span className="feature-item">Watershed Analysis</span>
                    <span className="feature-item">Cost Estimation</span>
                    <span className="feature-item">Progress Monitoring</span>
                    <span className="feature-item">As-Built Documentation</span>
                </div>
            </div>
            <div className="industry-image">
                <img src="/img/industries/construction.png" alt="Construction LiDAR Application" />
            </div>
        </div>
    );
};

export default Construction;